import { render, staticRenderFns } from "./CalendarOutline.vue?vue&type=template&id=5fa3b324"
import script from "./CalendarOutline.vue?vue&type=script&lang=js"
export * from "./CalendarOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports